/* ============
 * SalesReport Transformer
 * ============
 *
 * The transformer for the salesReport.
 */

import Transformer from './transformer';

export default class SalesReportTransformer extends Transformer {

  static fetch(salesReport) {
    return {
      id: salesReport.id,
      status: salesReport.status,
      name: salesReport.name,
      clearedInvoices: salesReport.cleared_invoices,
      clearedCredit: salesReport.cleared_credit,
    };
  }

  static send() {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/salesReport.js